// "Less than 1 month ago" used to back-date a tank to 15 days, so a tank
// filled yesterday read "Cycling 2 weeks" and its fishless-cycle quiet
// window ended two weeks early. For that bucket the keeper picks the day it
// was filled. Dates are the keeper's LOCAL calendar day, never toISOString
// (which is UTC and can be tomorrow in the evening in the Americas).

export function localDateString(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fillDateBounds(now = new Date()) {
  const min = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 31);
  return { min: localDateString(min), max: localDateString(now) };
}

// A YYYY-MM-DD inside the bounds, or null.
export function validFillDate(s, now = new Date()) {
  if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const { min, max } = fillDateBounds(now);
  return s >= min && s <= max ? s : null;
}
